
import { supabase } from "@/integrations/supabase/client";
import { AnalyticsEvent, TrackEventResponse } from "./types";

// Lightweight analytics tracking - no database triggers or materialized views
export const trackEvent = async (event: AnalyticsEvent): Promise<TrackEventResponse> => {
  try {
    // Skip tracking for debug meeting links
    if (event.properties?.meetingLinkId === 'debug') {
      console.log('Skipping analytics for debug meeting link');
      return { success: true };
    }

    console.log('📊 Tracking analytics event:', event.name, event.properties);

    // Simple direct insert without triggers or complex processing
    const { error } = await supabase
      .from('analytics_events')
      .insert({
        event_name: event.name,
        properties: event.properties || {},
        timestamp: new Date().toISOString(),
        user_id: null // Keep simple for now
      });

    if (error) {
      console.warn('Analytics tracking failed (non-critical):', error);
      // Don't throw - analytics failure shouldn't break core functionality
      return { success: false, error };
    }

    return { success: true };
  } catch (error) {
    console.warn('Analytics tracking error (non-critical):', error);
    // Analytics errors should never break the user experience
    return { success: false, error };
  }
};

// Re-export function name for consistency
export const REFRESH_ANALYTICS_FUNCTION = 'refresh_meeting_analytics';
